import axiosInstance from '../../services/axios/axios';

export const fetchUserData = data => {
	if (data?.familiarEsoId) {
		return axiosInstance
			.get('api/Identity/ImpersonationIdentity', {
				params: {
					impersonationId: data.familiarEsoId,
				},
			})
			.then(response => {
				return response?.data?.payload;
			});
	}
};
